import { isTestOrLocal } from "../constants/uri";
import posthog from "posthog-js";
import useInfoState from "../../zustand/infoState";
import authState from "../../zustand/authState";
import defaultPaymentInfoServiceInstance from "../../provider/paymentInfoService";
import useAuthState from "../../zustand/authState";
import usePaymentCheckoutState from "../../zustand/payment/checkout/paymentCheckoutState";

declare var window: any;
declare var sendinblue: any;

export const trackClearECommerce = () => {

    if (isTestOrLocal()) {
        console.log(`%cTag Manager: CLEAR E-Commerce\n\n ${JSON.stringify({ ecommerce: null })}\n\n`,"color: green; font-size: 14px");
        return;
    }

    try {
        const internal = useAuthState.getState().currentUserOverview?.internal;

        if (internal === true) {
            console.log('*** internal skip *** tag manager clear e-commerce');
            return;
        }
    } catch(err) {

    }

    window.dataLayer?.push( { ecommerce: null } );
}

export const trackEvent = (eventName, eventParams?) => {

    if (isTestOrLocal()) {
        console.log(`%cTag Manager: ${eventName}\n\n ${JSON.stringify({ event: eventName, ...eventParams })}\n\n`,"color: lightgreen; font-size: 14px");
        return;
    }

    try {
        const internal = useAuthState.getState().currentUserOverview?.internal;

        if (internal === true) {
            console.log('*** internal skip *** track event');
            console.log({event: eventName, ...eventParams});
            return;
        }
    } catch(err) {

    }

    try {
        window.dataLayer?.push(
            {
                event: eventName,
                ...eventParams
            }
        );
    }catch (err) {
        trackPosthog("tracking error ", { error: err });
    }

    trackPosthog("gtag " + eventName, { params: eventParams, name: eventName } );

};

export const trackPosthog = (eventName, params = undefined) => {

    if (isTestOrLocal()) {
         console.log(`%cPosthog Event: ${eventName}`,"color: #DC750E; font-size: 14px");
         console.log(`%c%o`, "color: #DC750E; font-size: 14px", params);
         return;
    }

    try {
        posthog.capture(eventName, params);
    } catch(err) {

    }
};

if (typeof window !== "undefined") {
    window.trackPosthog = trackPosthog;
}

export const trackECommerceEvent = (authContext, step, stepOption = undefined) => {

    const hasTracked = usePaymentCheckoutState.getState().hasTracked(step);

    if (hasTracked) {
        return;
    }

    usePaymentCheckoutState.getState().addTracked(step);

    const state = usePaymentCheckoutState.getState();

    const buyCourse =  state.buyMode === "course";
    const isBuyAbo = state.buyMode === "abo";
    const isGiftcard = state.isGiftcard;

    let item = null;

    if (isBuyAbo) {
        if (isGiftcard) {
            item = shAnalyticsGetAboItem(true);
        } else {
            item = shAnalyticsGetAboItem(false);
        }
    }  else {
        if (isGiftcard) {
            item = shAnalyticsGetCourseTrackitem(buyCourse, 'course-giftcard');
        } else {
            item = shAnalyticsGetCourseTrackitem(buyCourse, 'course');
        }
    }

    const transformedItem = {
        id: item.item_id,
        name: item.item_name,
        category: item.item_category,
        price: item.item_price
    }

    trackEvent(
        "checkout",
        {
            ecommerce: {
                checkout: {
                    actionField: {
                        step,
                        option: stepOption
                    },
                    products: [ transformedItem ]
                }
            }
        }
    );

}

export const trackFBEvent = (name, params = undefined, eventId = undefined) => {

}

export const initFBTracking = ({ mail, firstname, lastname }) => {

}

export const shAnalyticsSetUserProperties =  (props) => {
    trackEvent('user_properties', props);
};

export const shAnalyticsSetUserId = (uuid) => {
    // trackEvent('MEASUREMENT_ID', { user_id: uuid });
};

export const shAnalyticsGetCourseTrackitem = (course, category = 'course', item_list_id?, item_list_name?) => {
    if (!course) {
        return {
            item_category: category
        };
    }

    const brutto = course.price;

    return {
        item_id: course.id,
        item_list_id: item_list_id || (course.id > 9 ? "C0" : "C00") + course.id,
        item_list_name: item_list_name || "Courses Landingpage",
        item_name: category === 'course-giftcard' ? "Gutschein für " + course.title : course.title,
        item_category: category === 'course-giftcard'? "Kurs-Gutschein" : "Kurs",
        price: brutto,
        item_price: brutto,
        quantity: 1,
        affiliation: "Website",
        currency: 'EUR',
        index: 0
    }
}

export const shAnalyticsGetAboItem = (giftcard = false) => {
    if (typeof window !== 'undefined') {

        const brutto = window.abo?.price;
        const abo = useInfoState.getState().abo;

        return {
            item_id: giftcard ? 'abo-giftcard' : 'abo',
            item_list_id: "C001",
            item_list_name: "Courses Landingpage",
            item_name: giftcard ? '7hauben Pass Gutschein' : '7hauben Pass',
            item_category: giftcard ? "Abo-Gutschein" : "Abo",
            price: brutto,
            item_price: brutto,
            quantity: 1,
            currency: 'EUR',
            affiliation: "Website",
            index: 0,
            discount: defaultPaymentInfoServiceInstance.calculatePriceForProduct
                        (abo, authState.getState().currentUserOverview?.customAboPrice, giftcard)
        }
    }

    return null;
}

export const shAnalyticsParseAboMode = (mode) => {
    if (mode === 'giftcard') {
        return shAnalyticsGetAboItem(true);
    } else {
        return shAnalyticsGetAboItem(false);
    }
}

export const shSIBIdentify = (mail) => {
    if (window?.sendinblue) {
        // call without additional properties
        sendinblue.identify(mail);
    }
}

export const shSIBTrackEvent = (eventName, eventProperties = undefined, eventData = undefined) => {
    if (window?.sendinblue) {
        try {
            sendinblue.track(eventName, eventProperties, eventData);
        } catch(err) {
            console.log('*** send in blue track error', err);
        }
    }
}
